import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InputField from "../../ui/form/InputField";
import SelectField from "../../ui/form/SelectField";
import apiRequest from "../../../utils/admin/apiRequest";
import toast from "react-hot-toast";
import UploadLogo from "./UploadLogo";
import UploadFavicon from "./UploadFavicon";
import UploadOpenGraph from "./UploadOpenGraph";

const SiteSetting = () => {
  const setting = useSelector((state) => state?.globalState?.siteSetting);
  const siteSetting = setting?.site_settings || {};

  const defaultValues = {
    site_name: "",
    brand_name: "",
    site_tagline: "",
    site_logo: "",
    site_favicon: "",
    timezone: "Asia/Kolkata",
    currency: "INR",
    currency_symbol: "₹",
    default_language: "en",
  };

  const [formData, setFormData] = useState(defaultValues);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (siteSetting && Object.keys(siteSetting).length > 0) {
      setFormData((prev) => ({
        ...prev,
        ...siteSetting,
      }));
    }
  }, [siteSetting]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiRequest.updateSetting({
        data: { site_settings: formData },
      });
      console.log(response);
      
      
      toast.success(response?.data?.message);
    } catch (error) {
      console.error(error);
      // toast.error(response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className="p-4 space-y-4 bg-white rounded" onSubmit={handleSubmit}>
        <InputField
          label="Brand Name"
          id="brand_name"
          name="brand_name"
          value={formData.brand_name}
          onChange={handleChange}
        />
        <InputField
          label="Site Name"
          id="site_name"
          name="site_name"
          value={formData.site_name}
          onChange={handleChange}
        />
        <InputField
          label="Site Tagline"
          id="site_tagline"
          name="site_tagline"
          value={formData.site_tagline}
          onChange={handleChange}
        />
        <SelectField
          label="Timezone"
          id="timezone"
          name="timezone"
          value={formData.timezone}
          onChange={handleChange}
          options={[{ label: "Asia/Kolkata", value: "Asia/Kolkata" }]}
        />
        <SelectField
          label="Currency"
          id="currency"
          name="currency"
          value={formData.currency}
          onChange={handleChange}
          options={[{ label: "INR", value: "INR" }]}
        />
        <InputField
          label="Currency Symbol"
          id="currency_symbol"
          name="currency_symbol"
          value={formData.currency_symbol}
          onChange={handleChange}
        />
        <SelectField
          label="Default Language"
          id="default_language"
          name="default_language"
          value={formData.default_language}
          onChange={handleChange}
          options={[{ label: "English", value: "en" }]}
        />

        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-sm text-white rounded bg-primary hover:bg-primaryDark"
        >
          {loading ? "Saving..." : "Update Settings"}
        </button>
      </form>
      <UploadLogo />
      <UploadFavicon />
      <UploadOpenGraph />
    </>
  );
};

export default SiteSetting;
